// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 296 ? "ea88be26" : chunkId) + "." + {"296":"6e887dc44926260c","9260":"3fd94c950a2f1fed"}[chunkId] + ".js";
};